// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__Hjbs6","left":"Footer_left__onMxQ","right":"Footer_right__aeYQz","disabled":"Footer_disabled__V6hIp"};